import { SelectOption } from "@/interfaces/vuetify/selectOption";

export const enum Qualities {
  low = "360p",
  medium = "540p",
  high = "720p"
}

export const QualityOptions: SelectOption[] = [
  { value: Qualities.low, text: "360p (nHD) @ 15 fps (600 Kbps max)" },
  { value: Qualities.medium, text: "540p (qHD) @ 15 fps (1.4 Mbps max)" },
  { value: Qualities.high, text: "720p (HD) @ 15 fps (1.4 Mbps max)" }
];

const mapping: { [k: string]: [number, number, number, number] } = {
  low: [640, 360, 15, 600],
  medium: [960, 540, 15, 1400],
  high: [1280, 720, 15, 1400]
};

export const QualityMappings = {
  get(key: Qualities): [number, number, number, number] {
    if (Qualities.low === key) {
      return mapping.low;
    }
    if (Qualities.medium === key) {
      return mapping.medium;
    }
    if (Qualities.high === key) {
      return mapping.high;
    }
    return mapping.low;
  }
};
